var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { cloneElement, useContext } from 'react';
import TabInner from './Tab';
import classNames from 'classnames';
import { ThemeContext } from '../../context/ThemeContext';
var TabsInner = function (_a, ref) {
    var children = _a.children, value = _a.value, onChange = _a.onChange, className = _a.className, props = __rest(_a, ["children", "value", "onChange", "className"]);
    var tabs = useContext(ThemeContext).theme.tabs;
    var classes = classNames(tabs.content, className);
    return (_jsx("div", __assign({ ref: ref, "aria-label": "Tabs", role: "tablist" }, props, { className: classes }, { children: children.map(function (child, index) {
            return cloneElement(child, {
                key: child.props.value,
                activeValue: value,
                onClick: function (value) {
                    onChange && onChange(value);
                },
            });
        }) })));
};
// Make forwardRef work with generic component
var Tabs = React.forwardRef(TabsInner);
export default Object.assign(Tabs, { TabInner: TabInner });
